import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterACircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLetterACircle"><Path d="M12.0527 9.11523L13.1895 12.6484H10.8164L11.9531 9.11523H12.0527Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.1504 7.54492L8.15039 16H9.73242L10.4355 13.8145H13.5645L14.2734 16H15.8555L12.8555 7.54492H11.1504Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterACircle;
